import React, { FC } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { useSystemControllerRunOperationMutation } from '@services/merchantAdminApi';
import SnackbarUtils from '@features/common/snackbar-utils';
import styles from './OperationsComponent.module.scss';

interface OperationsComponentProps {
}

interface OperationRowProps {
    label: string;
    operationName: string;
}

const OperationRow: FC<OperationRowProps> = ({ label, operationName }) => {
    const [runOperationMutation, { isLoading }] = useSystemControllerRunOperationMutation();

    const runOperation = async () => {
        try {
            await runOperationMutation({ operationName }).unwrap();
            SnackbarUtils.success('Operation completed');
        } catch {
            // Errors are already surfaced by the global rtk-query error middleware.
        }
    };

    return (
        <Grid size={12} container alignItems="center">
            <Grid size={5}>
                <Typography variant="body2">{label}</Typography>
            </Grid>
            <Grid size={1}>
                <Button
                    variant="contained"
                    onClick={runOperation}
                    disabled={isLoading}
                    data-testid={`run-${operationName}`}
                >
                    Run
                </Button>
            </Grid>
        </Grid>
    );
};

const OperationsComponent: FC<OperationsComponentProps> = () => (
    <Grid container spacing={1} className={styles.OperationsComponent} data-testid="OperationsComponent">
        <OperationRow label="Sync Merchant data to dependent services" operationName="SyncMerchants" />
        <OperationRow label="Sync Product Catalogues to Scan Service" operationName="SyncCatalogueProducts" />
    </Grid>
);
export default OperationsComponent;
